export default "__VITE_ASSET__BZ1MoAVH__"